var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwitchColorModel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.033 92.7832V129.2C88.033 133.317 84.5496 136.8 80.4329 136.8H34.1996C30.0829 136.8 26.5996 133.317 26.5996 129.2V51.9335C26.5996 47.8168 30.0829 44.333 34.1996 44.333H52.883H80.4329C84.5496 44.333 88.033 47.8168 88.033 51.9335V75.0503",
    fill: "#00BAC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1171 79.167V102.284L49.4004 90.5673L61.1171 79.167Z",
    fill: "#170F4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130.784 94.6838H60.8008V86.4502H122.551V17.7336H80.7508V48.4502H72.5174V9.5H130.784V94.6838Z",
    fill: "#170F4F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.667 71.25H99.4336V78.8505H107.667V71.25Z",
    fill: "#170F4F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1493 140.916H22.166V40.2168H92.1493V79.1662H83.916V48.4497H30.3993V132.683H83.916V101.967H92.1493V140.916Z",
    fill: "#170F4F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4325 117.483H53.1992V125.083H61.4325V117.483Z",
    fill: "#170F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchColorModel);
export default __webpack_public_path__ + "static/media/switch-color-model.6a8ba248cd16695796ce174e16bc7d39.svg";
export { ForwardRef as ReactComponent };